import React from 'react';

/**
 * Product image with (a) friction against saving/dragging and
 * (b) a diagonal ARTHUR FITZ watermark baked into the DOM as a
 * separate overlay layer. It is impossible to make an <img> truly
 * unsaveable on the web — but this combination stops the casual
 * right-click-save + drag-to-desktop + long-press-save flows and
 * ensures any screenshot carries the brand.
 *
 * Props:
 *  - src, alt, className, width, height, loading, sizes, srcSet: forwarded
 *  - watermark (bool, default true): show/hide the overlay
 *  - watermarkOpacity: 0-1 (default 0.22)
 */
export function ProtectedImage({
  src,
  alt = '',
  className = '',
  width,
  height,
  loading = 'lazy',
  sizes,
  srcSet,
  watermark = true,
  watermarkOpacity = 0.22,
  ...rest
}) {
  const block = (e) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };
  return (
    <div
      className={`relative select-none ${className}`}
      onContextMenu={block}
      onDragStart={block}
      style={{ WebkitTouchCallout: 'none', WebkitUserSelect: 'none', userSelect: 'none' }}
      data-testid="protected-image"
      {...rest}
    >
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        loading={loading}
        sizes={sizes}
        srcSet={srcSet}
        draggable={false}
        onContextMenu={block}
        onDragStart={block}
        className="w-full h-full object-cover pointer-events-none"
        style={{ WebkitUserDrag: 'none', userDrag: 'none' }}
      />
      {watermark && (
        <div
          aria-hidden="true"
          className="absolute inset-0 pointer-events-none flex items-center justify-center"
          style={{
            backgroundImage: 'url(/assets/brand/watermark-arthur-fitz.webp)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: '75% auto',
            opacity: watermarkOpacity,
            mixBlendMode: 'screen',
          }}
        />
      )}
    </div>
  );
}

export default ProtectedImage;
